import { useEffect, useMemo, useCallback } from "react";
import { useRole, useContract } from "../../../contract/ContractContext";
import { useSavedContractsContext } from "../../../contract/landing/SavedContracts";
import {
  ContractViewModel,
  Role,
} from "../../../contract/model/ContractViewModel";
import ContinueLaterForm from "./ContinueLaterForm";
import FlyoutModal from "@teamscheme/flyout-modal";

function useSaveLocal({
  savedContracts,
}: {
  savedContracts: {
    save(contract: ContractViewModel): void;
    isLoading: boolean;
    savedContracts: { params?: { id: string }; role: Role }[];
  };
}) {
  const contract = useContract();
  const role = useRole();

  const {
    save: saveContract,
    isLoading,
    savedContracts: _savedContracts,
  } = savedContracts;

  const save = useCallback(
    function save() {
      if (!isLoading) {
        saveContract(contract);
      }
    },
    [isLoading, saveContract, contract]
  );

  const isSaved = useMemo(
    () =>
      _savedContracts.filter(
        (x) => x.params && x.params.id === contract.id && x.role === role
      ).length,
    [_savedContracts, contract.id, role]
  );

  return useMemo(
    () => ({
      save,
      isSaved,
    }),
    [isSaved, save]
  );
}

export interface ContinueLaterProps {
  isOpen: boolean;
  onClose(): void;
}

export default function ContinueLaterModal({
  isOpen,
  onClose,
}: ContinueLaterProps) {
  const savedContracts = useSavedContractsContext();

  const saveLocal = useSaveLocal({ savedContracts });

  const { save } = saveLocal;

  useEffect(() => {
    if (isOpen) {
      save();
    }
  }, [isOpen, save]);

  return (
    <FlyoutModal isOpen={isOpen} onClose={onClose}>
      <h1>Ble du ikke ferdig?</h1>
      <ContinueLaterForm isOpen={isOpen} />
    </FlyoutModal>
  );
}
